export default __webpack_public_path__ + "static/media/xero_landing_page_banner.c65eef4a.png";